import { useMemo } from 'react';
import styled from 'styled-components';

import { colors, fontWeights } from 'theme';

const InitialsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.selectionGrey};
  font-size: 64px;
  font-weight: ${fontWeights.bold};
  text-align: center;
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
`;

type Props = {
  name: string | undefined;
  size: number;
};

export function Initials({ name, size }: Props) {
  const firstLetter = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (!name || !name.length) return '';
    return name[0] || '';
  }, [name]);

  return (
    <InitialsContainer
      style={{ maxWidth: size || '100%', maxHeight: size || '100%' }}
    >
      {firstLetter}
    </InitialsContainer>
  );
}
